<template>
  <div class="header">
    <img class="header-logo" src="../assets/logo_slogan.svg" alt="Logo PortAventura">
    <Languages />
  </div>
</template>

<script>
import Languages from '@/components/Languages.vue'
export default {
  name: 'HeaderPort',
  components: {
    Languages
  }
}
</script>

<style>
.header {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  position: fixed;
  --tw-shadow-color: 0, 0, 0;
  --tw-shadow: 0 4px 6px -1px rgba(var(--tw-shadow-color), 0.1), 0 2px 4px -1px rgba(var(--tw-shadow-color), 0.06);
  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  width: 100vw;
  z-index: 1;
}
@media (min-width: 640px) {
  .header {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
.header-logo {
  max-height: 3rem;
}
</style>
